import { Alert } from "@volca/ui/components/ui/alert";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";

export const OnboardingLoadError = ({ retry }: { retry: () => void }) => (
  <Stack gap={4} align="stretch" className="mx-auto max-w-3xl p-6">
    <Alert color="danger">
      Could not load your setup information. Please try again.
    </Alert>
    <Button onClick={retry}>Try again</Button>
  </Stack>
);
